import * as R from 'ramda';

export default function DenyChangeConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  pmDataService,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDenyChange = _handleConfirmDenyChange;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }
  /** *********************************************
   * Private Functions
   */

  function _handleConfirmDenyChange() {
    loaderService.showViewLoader = true;
    vm.change.explanation = vm.explanation;
    let changeToSave = null;
    if (vm.change.changeEntity === 'Batch') {
      changeToSave = _transformBatchChangeForSave(vm.change);
    } else {
      changeToSave = _transformChangeForSave(vm.change);
    }
    pmDataService.denySyncedChanges(changeToSave).then(() => {
      let alertMessage;
      if (vm.change.changeEntity === 'Section Title') {
        alertMessage = `Section ${vm.change.documentSectionCode} Title`;
      } else if (vm.change.changeEntity === 'Section Body') {
        alertMessage = `Section ${vm.change.documentSectionCode} Body`;
      } else if (vm.change.changeEntity === 'EndNote') {
        alertMessage = `Endnote ${vm.change.tag}`;
      } else if (vm.change.changeEntity === 'Section Sort Order') {
        alertMessage = `Section ${vm.change.documentSectionCode}`;
      } else if (vm.change.changeEntity === 'Section Moved') {
        alertMessage = `Section ${vm.change.documentSectionCode}`;
      } else {
        alertMessage = `Bach ${vm.change.documentSectionCode}`;
      }
      alertMessage += ' synchronization with the recommendation has been successfully removed.';
      alerts.success(alertMessage);

      if (vm.updateCallback) {
        vm.updateCallback(vm.change);
      }
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshPMDocuments');
      $rootScope.$broadcast('refreshPmChangeLog');
    });

    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.confirmDenyChangeDialog);
  }

  function _transformChangeForSave(change) {
    const changeToSave = {
      policyDocumentId: vm.changedIds.policyDocumentId,
    };
    // eslint-disable-next-line max-len
    if (
      change.changeEntity === 'Section Title' ||
      change.changeEntity === 'Section Body' ||
      change.changeEntity === 'Section Moved' ||
      change.changeEntity === 'Section Sort Order'
    ) {
      if (change.changeType === 'Created') {
        changeToSave.addedMasterSectionIds = [change];
      } else if (change.changeType === 'Updated') {
        changeToSave.updatedSectionIds = [change];
      } else {
        changeToSave.deletedSectionIds = [change];
      }
    } else if (change.changeEntity === 'EndNote') {
      if (change.changeType === 'Created') {
        changeToSave.createdMasterEndNoteIds = [change];
      } else if (change.changeType === 'Updated') {
        changeToSave.updatedEndNoteIds = [change];
      }
    }
    return changeToSave;
  }

  function _transformBatchChangeForSave(change) {
    const changeToSave = {
      policyDocumentId: vm.changedIds.policyDocumentId,
    };
    changeToSave.addedMasterSectionIds = [];
    changeToSave.updatedSectionIds = [];
    changeToSave.deletedSectionIds = [];
    // eslint-disable-next-line max-len
    if (change.items && change.items.length > 0) {
      R.forEach(item => {
        item.explanation = change.explanation;
        if (item.changeType === 'Created') {
          changeToSave.addedMasterSectionIds.push(item);
        } else if (item.changeType === 'Updated') {
          changeToSave.updatedSectionIds.push(item);
        } else {
          changeToSave.deletedSectionIds.push(item);
        }
      }, change.items);
    }
    return changeToSave;
  }
}

DenyChangeConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'pmDataService',
  'loaderService',
  'ssDialogService',
];
